{
  "de": {
    "question_list": {
      "actions": {
        "cancel": "Rückgängig machen",
        "cancelOrder": "Abbrechen",
        "delete": "Löschen",
        "deleteMultipleQuestionLists": "Löschen …",
        "delete_cancel": "Abbrechen",
        "edit": "Bearbeiten",
        "new": "FAQ-Liste",
        "reorderQuestions": "Fragen neu anordnen",
        "save": "Speichern",
        "saveOrder": "Reihenfolge speichern",
        "submit": "Erstellen",
        "tickBoxesDeletion": "Aktivieren Sie die Kontrollkästchen der FAQs, die Sie löschen möchten, und klicken Sie dann auf die Schaltfläche oben, um das Löschen zu bestätigen oder abzubrechen."
      },
      "attributes": {
        "description": "Beschreibung",
        "name": "Name",
        "question_list": "FAQ"
      },
      "labels": {
        "allUnits": "Alle Einheiten",
        "descriptionOptional": "Beschreibung (optional)",
        "editFAQ": "FAQ bearbeiten",
        "faq": "FAQ",
        "faq_all_projects": "FAQs aller Projekte",
        "info": "Haben Sie eine Frage zu Ihrem Zuhause? Hier finden Sie die am häufigsten gestellten Fragen und ihre Antworten!",
        "questions": " Keine Fragen | 1 Frage | {count} Fragen",
        "questions_count": "Fragen",
        "showQuestionListFor": "FAQs anzeigen für",
        "title": "Häufig gestellte Fragen"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Hier finden Sie Antworten auf allgemeine Fragen oder Fragen, die andere gestellt haben.",
            "title": "Häufig gestellte Fragen"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Geben Sie Antworten auf allgemeine Fragen, die Ihre Kunden haben könnten.",
            "title": "Erstellen Sie Ihre erste FAQ-Liste"
          }
        }
      },
      "toasts": {
        "create": "FAQ-Liste erstellt",
        "delete": "FAQ-Liste gelöscht",
        "update": "FAQ-Liste aktualisiert"
      },
      "validation": {
        "needName": "Titel erforderlich",
        "selectQuestionList": "Wählen Sie mindestens 1 FAQ aus"
      }
    }
  }
}
